import BaseModel from "../base_model.js";
import I18n from "../../base/i18n.js.jsx";

import { TopBarHeight } from "../../admin/constants.js";

class RawProjectDeveloperModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        sortKey: "name"
      },
      {
        name: "createdAt",
        displayName: this.fieldDisplayName("created_at"),
        type: "dateTime",
        dateFormat: "DD.MM.YYYY",
        timeFormat: "HH:mm",
        sortKey: "created_at"
      }
    ]
  }

  rawFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        required: true
      },
      {
        name: "description",
        displayName: this.fieldDisplayName("description"),
        type: "WYSIWYG",
        weight: 12,
        viewportTopOffset: parseInt(TopBarHeight)
      },
    ]
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    if(!item.id) {
      return I18n.t(`${this.i18nScope()}.new`);
    }
    if(!item.name) {
      return `${I18n.t(`${this.i18nScope()}.name`, {count: 1} )} ${item.id}`;
    }
    return item.name;
  }

  i18nScope() {
    return "model.projects.developer";
  }

}
const ProjectDeveloperModel = new RawProjectDeveloperModel();
export { RawProjectDeveloperModel, ProjectDeveloperModel }

